import React, { useMemo, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'

import { useAppSelector } from 'redux/Hook'
import { CardList } from './CardList'
import { CardPagination } from './CardPagination'
import { setPage, setPerPage } from 'redux/slices/TextAnalysis'
import { fetchContributions } from 'redux/thunks/TextAnalysis'
import { CardEmpty } from './CardEmpty'

const CardContainer = () => {
  const dispatch = useDispatch()
  const {
    data,
    total,
    queries: { page, per_page },
  } = useAppSelector((state) => state.textAnalysis.main)

  const isDataAvailable = useMemo(
    () => data && Array.isArray(data) && data.length > 0,
    [data],
  )

  const onPageChange = useCallback(
    (newPage: number) => {
      dispatch(setPage(newPage + 1))
      dispatch(fetchContributions())
    },
    [dispatch],
  )

  const onRowsPerPageChange = useCallback(
    (targetPage: number) => {
      dispatch(setPerPage(targetPage))
    },
    [dispatch],
  )

  return (
    <Box width="100%" data-testid="ta-card-container">
      <Grid item xs={12} md={12} lg={9}>
        {isDataAvailable && <CardList />}
      </Grid>
      <Grid item xs={12}>
        {isDataAvailable ? (
          <CardPagination
            count={total}
            page={page - 1}
            pageSize={per_page}
            onPageChange={onPageChange}
            onRowsPerPageChange={onRowsPerPageChange}
          />
        ) : (
          <CardEmpty />
        )}
      </Grid>
    </Box>
  )
}

export { CardContainer }
